<script lang="ts">
	//UI
	import { SlotSelect, SelectOpenCloseIcon } from "@hitit/new_ui";
	import { createEventDispatcher } from "svelte";
	//Utils
	//Types
	//Props
	export let label = "";
	export let items: string[] | number[] = [];
	export let value: any = "";
	//Constants
	const dispatch = createEventDispatcher();
	//Variables
	//Functions
	function mappedItems(items: string[] | number[]) {
		return items.map((v) => ({
			label: String(v),
			value: v,
			display: String(v),
		}));
	}
	function changeHandler(e: Event) {
		const target = e.target as HTMLSelectElement;

		dispatch("change", target.value as any);
	}
	//Do
</script>

<div class="filter-option">
	<span class="label"> {label} </span>
	<div class="select">
		<SlotSelect
			on:change={changeHandler}
			let:displayValue
			bind:value={value}
			backgroundColor={"#f0f0f4"}
			items={mappedItems(items)}
		>
			<div class="value-box">
				<span class="value">{displayValue}</span>
				<span class="icon">
					<SelectOpenCloseIcon />
				</span>
			</div>
		</SlotSelect>
	</div>
</div>

<style lang="scss">
	@import "../../../variables.scss";
	.filter-option {
		width: 100%;
		gap: 10px;
		display: flex;
		align-items: center;

		.label {
			width: 90px;
			color: #46474b;
			font-weight: 550;
		}

		.select {
			flex-grow: 1;
			height: 32px;
			.value-box {
				display: flex;
				justify-content: space-between;
				width: 100%;
				width: 100%;
				box-sizing: border-box;
				padding: 0px 10px;
				color: #46474b;
				.icon {
					width: 19.8px;
					height: 10px;
				}
			}
		}
	}
	@include DesktopSize {
		.filter-option {
			width: auto;

			.label {
				width: auto;
				font-size: 1.25rem;
				text-align: center;
			}

			.select {
				width: 130px;
			}
		}
		/*  */
	}
</style>
